import { FeaturesSection } from "../sections/features";
import { HeroSection } from "../sections/hero";
import { HowItWorksSection } from "../sections/how-it-works";
// import { TestimonialsSection } from "../sections/testimonial";
import { log } from "../utils/log_utils";


export const Landing = () =>{

  const setAnalysis = () => log("set Analysis login called")

  return (
  <div className="w-full bg-gray-50">
    <HeroSection setAnalysis={setAnalysis} />
    {/* {isLoading && <Loader /> } */}
    <FeaturesSection />
    <HowItWorksSection />
    {/* <TestimonialsSection /> */}
  </div>
  );
}